import { render } from "./SuplierBalance.vue?vue&type=template&id=26071ecb&scoped=true"
import script from "./SuplierBalance.vue?vue&type=script&lang=js"
export * from "./SuplierBalance.vue?vue&type=script&lang=js"

import "./SuplierBalance.vue?vue&type=style&index=0&id=26071ecb&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26071ecb"]])

export default __exports__